import { render, staticRenderFns } from "./ChatUsers.vue?vue&type=template&id=32fcf708&scoped=true"
import script from "./ChatUsers.vue?vue&type=script&lang=js"
export * from "./ChatUsers.vue?vue&type=script&lang=js"
import style0 from "./ChatUsers.vue?vue&type=style&index=0&id=32fcf708&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32fcf708",
  null
  
)

export default component.exports